import React from "react";
import LegalLayout, { Section } from "@/pages/LegalLayout";
import { useLanguage } from "@/context/LanguageContext";

const Privacy = () => {
  const { lang } = useLanguage();
  return (
    <LegalLayout
      testId="privacy-page"
      eyebrow={lang === "ta" ? "சட்டம்" : "Legal"}
      title={lang === "ta" ? "தனியுரிமை கொள்கை" : "Privacy Policy"}
    >
      <p>
        {lang === "ta"
          ? "உங்கள் தனியுரிமை எங்களுக்கு முக்கியம். TNPSC தமிழ் செயலியை பயன்படுத்தும்போது நாங்கள் எந்த தகவல்களை சேகரிக்கிறோம், அவற்றை எவ்வாறு பயன்படுத்துகிறோம் என்பதை இந்த கொள்கை விளக்குகிறது."
          : "Your privacy is important to us. This policy explains what information we collect when you use the TNPSC Tamil app, and how we use it."}
      </p>

      <Section title={lang === "ta" ? "1. நாங்கள் சேகரிக்கும் தகவல்" : "1. Information we collect"}>
        <p>
          {lang === "ta"
            ? "(a) கணக்கு தகவல்: பெயர், மின்னஞ்சல், தொலைபேசி எண் (நீங்கள் வழங்கும் போது)."
            : "(a) Account info: name, email, phone number (when you provide it)."}
        </p>
        <p>
          {lang === "ta"
            ? "(b) பயன்பாட்டுத் தகவல்: எடுத்த தேர்வுகள், மதிப்பெண்கள், படிப்பு செயல்பாடு."
            : "(b) Usage info: tests taken, scores, study activity within the app."}
        </p>
        <p>
          {lang === "ta"
            ? "(c) சாதன & கணக்கீட்டுத் தகவல்: சாதன வகை, OS பதிப்பு, கோளாறு தகவல்."
            : "(c) Device & analytics info: device type, OS version, crash logs."}
        </p>
      </Section>

      <Section title={lang === "ta" ? "2. நாங்கள் எவ்வாறு பயன்படுத்துகிறோம்" : "2. How we use it"}>
        <p>
          {lang === "ta"
            ? "உங்கள் தேர்வு முன்னேற்றத்தைக் கண்காணிக்க, AI விளக்கங்களை வழங்க, பலவீன பகுதிகளை சுட்டிக்காட்ட, மற்றும் சேவையை மேம்படுத்த உங்கள் தரவை பயன்படுத்துகிறோம். உங்கள் தனிப்பட்ட தரவை மூன்றாம் தரப்பினருக்கு ஒருபோதும் விற்க மாட்டோம்."
            : "We use your data to track your prep progress, deliver AI explanations, surface weak areas, and improve the service. We never sell your personal data to third parties."}
        </p>
      </Section>

      <Section title={lang === "ta" ? "3. மூன்றாம் தரப்பு சேவைகள்" : "3. Third-party services"}>
        <p>
          {lang === "ta"
            ? "செயலி இயக்க தேவையான மூன்றாம் தரப்பு சேவைகளை (கட்டண நிறுவனங்கள், கணக்கீடு, AI வழங்குநர்கள்) பயன்படுத்துகிறோம். இவை வரம்புக்குட்பட்ட தரவை மட்டுமே பெறுகின்றன."
            : "We use third-party providers (payment processors, analytics, AI providers) strictly to operate the app. They receive only the limited data required to deliver their service."}
        </p>
      </Section>

      <Section title={lang === "ta" ? "4. தரவு பாதுகாப்பு" : "4. Data security"}>
        <p>
          {lang === "ta"
            ? "உங்கள் தரவை பாதுகாக்க தொழில் தரத்தில் என்க்ரிப்ஷன், அணுகல் கட்டுப்பாடுகள், மற்றும் வழக்கமான பாதுகாப்பு ஆய்வுகளை பயன்படுத்துகிறோம்."
            : "We use industry-standard encryption, access controls, and regular security reviews to protect your data."}
        </p>
      </Section>

      <Section title={lang === "ta" ? "5. குழந்தைகள்" : "5. Children"}>
        <p>
          {lang === "ta"
            ? "செயலி 13 வயதுக்கு மேற்பட்டவர்களுக்கு வடிவமைக்கப்பட்டுள்ளது. 13 வயதுக்குக் குறைவான குழந்தைகளிடமிருந்து தெரிந்தோ தனிப்பட்ட தரவை சேகரிக்க மாட்டோம்."
            : "The app is designed for users 13 years and older. We do not knowingly collect personal data from children under 13."}
        </p>
      </Section>

      <Section title={lang === "ta" ? "6. உங்கள் உரிமைகள்" : "6. Your rights"}>
        <p>
          {lang === "ta"
            ? "உங்கள் தனிப்பட்ட தரவை அணுக, புதுப்பிக்க அல்லது நீக்க உங்களுக்கு உரிமை உள்ளது. கோரிக்கையை வழங்க, tnpsctamilapp@gmail.com க்கு எழுதுங்கள்."
            : "You have the right to access, update, or delete your personal data. To make a request, email tnpsctamilapp@gmail.com."}
        </p>
      </Section>

      <Section title={lang === "ta" ? "7. மாற்றங்கள்" : "7. Changes"}>
        <p>
          {lang === "ta"
            ? "இந்த கொள்கை அவ்வப்போது புதுப்பிக்கப்படலாம். குறிப்பிடத்தக்க மாற்றங்களை செயலி அல்லது மின்னஞ்சல் வழியாக தெரிவிக்கப்படும்."
            : "This policy may be updated from time to time. Significant changes will be communicated within the app or via email."}
        </p>
      </Section>

      <Section title={lang === "ta" ? "8. தொடர்பு" : "8. Contact"}>
        <p>
          {lang === "ta" ? "தனியுரிமை தொடர்பான கேள்விகளுக்கு: " : "For privacy-related questions: "}
          <a
            href="mailto:tnpsctamilapp@gmail.com"
            className="text-blue-900 font-semibold underline decoration-amber-400 underline-offset-4"
          >
            tnpsctamilapp@gmail.com
          </a>
        </p>
      </Section>
    </LegalLayout>
  );
};

export default Privacy;
